import { CompanyCountry } from "services/company/companyTypes";

export enum IncoroporationFormStep {
  CONSENT = "CONSENT",
  PARTNER_OFFERS = "PARTNER_OFFERS",
  BEFORE_START = "BEFORE_START",
  COMPANY = "COMPANY",
  DIRECTOR = "DIRECTOR",
  SHARES = "SHARES",
  IDENTITY = "IDENTITY",
  CH_VERIFICATION = "CH_VERIFICATION",
  BASKET = "BASKET",
  CONFIRM = "CONFIRM",
  CHARGE = "CHARGE",
  COMPLIANCE_CALL = "COMPLIANCE_CALL",
  COMPLIANCE_WAIT = "COMPLIANCE_WAIT",
  COMPLETE = "COMPLETE",
}

export const FORM_STEP_TO_PATH: Record<IncoroporationFormStep, string> = {
  [IncoroporationFormStep.CONSENT]: "consent",
  [IncoroporationFormStep.PARTNER_OFFERS]: "partner-offers",
  [IncoroporationFormStep.BEFORE_START]: "before-start",
  [IncoroporationFormStep.COMPANY]: "company",
  [IncoroporationFormStep.DIRECTOR]: "director",
  [IncoroporationFormStep.SHARES]: "particulars",
  [IncoroporationFormStep.IDENTITY]: "identity",
  [IncoroporationFormStep.CH_VERIFICATION]: "ch-verification",
  [IncoroporationFormStep.BASKET]: "basket",
  [IncoroporationFormStep.CONFIRM]: "confirm",
  [IncoroporationFormStep.CHARGE]: "charge",
  [IncoroporationFormStep.COMPLIANCE_CALL]: "final-call",
  [IncoroporationFormStep.COMPLIANCE_WAIT]: "final-check",
  [IncoroporationFormStep.COMPLETE]: "complete",
};

export const COUNTRY_NAME_TO_CODE: Record<string, CompanyCountry> = {
  ENGLAND: CompanyCountry.EW,
  "ENGLAND & WALES": CompanyCountry.EW,
  "NORTHERN IRELAND": CompanyCountry.NI,
  WALES: CompanyCountry.WA,
  SCOTLAND: CompanyCountry.SC,
};
